import { defineSlotRecipe } from '@chakra-ui/react'

export const tooltipSlotRecipe = defineSlotRecipe({
  slots: ['base', 'content'],
  base: {
    content: {
      bg: 'brand.blue',
      color: 'white',
      borderRadius: 'sm',
      fontWeight: 400,
      lineHeight: '175%',
    },
  },
})
